import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          full_name: string | null;
          role: 'admin' | 'finance' | 'legal' | 'viewer';
          is_active: boolean;
          created_at: string;
          updated_at: string;
        };
      };
      contracts: {
        Row: {
          id: string;
          title: string;
          contract_type: 'payable' | 'receivable';
          status: 'draft' | 'active' | 'suspended' | 'terminated' | 'expired';
          start_date: string;
          end_date: string | null;
          renewal_date: string | null;
          total_value: number | null;
          summary: string | null;
          owner_user_id: string;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['contracts']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['contracts']['Insert']>;
      };
    };
  };
};
